export default __webpack_public_path__ + "static/bg-area-003975fd508386fce933ec64b636652e.png";